import { createFileRoute } from '@tanstack/react-router';
import { TeamCatalogPage } from '@/pages/organization/org-functions/OrgFunctionCatalogPage';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/$slug/organization/teams/')({
  component: TeamCatalogPage,
  validateSearch: dataTableSearchSchema({})
});
